export const getInitialsFromName = (name?: string): string => {
  if (!name?.trim()) return '';

  const parts = name.trim().split(/\s+/);
  const firstInitial = parts[0][0].toUpperCase();
  const lastInitial =
    parts.length > 1 ? parts[parts.length - 1][0].toUpperCase() : '';

  return firstInitial + lastInitial;
};
